import { uuid } from '../utils';
import {
  ANIMATION
} from './categories';

export default {
  id: uuid(),
  priority: 1,
  name: 'Loops',
  thumbnail: './Loops/Loops_Thumb.jpg',
  categories: [ ANIMATION ],
  content: [
    'https://vimeo.com/865327122',
    'https://vimeo.com/865325257',
    'https://vimeo.com/865322824',
    'https://vimeo.com/234725615',
    'https://vimeo.com/210048163',
    'https://vimeo.com/184188892',
    'https://vimeo.com/174807224',
    'https://vimeo.com/81565710',
    'https://vimeo.com/9946244'
  ]
};




// WEBPACK FOOTER //
// ./src/projects/loops.js